package com.fireavert.topnav.client.presentation

data class TopNavViewState(val firstName: String = "", val lastName: String = "", val roles: String = "")
